export const API_BASE_URL = '/api/v1';

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/radharanicollection041?stkn=MWNmMDk0cmZkcjdyNw==',
  facebook: 'https://www.facebook.com/share/1BqGrT1pdf/',
  whatsapp: 'https://wa.me/918740878580',
  whatsappCommunity: 'https://wa.me/918740878580',
};

export const IMAGE_PLACEHOLDER = '/images/placeholder.svg';

export const STORE_NAME = 'Radha Rani Collection';

export const UPI_ID = '8875980411-2@ybl';

export const COUPON_STORAGE_KEY = 'rrc_applied_coupon';

export const ORDER_STATUS = {
  PLACED: 'placed',
  CONFIRMED: 'confirmed',
  PACKED: 'packed',
  SHIPPED: 'shipped',
  OUT_FOR_DELIVERY: 'outForDelivery',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
};

export const ORDER_STATUS_LABELS = {
  paymentPending: 'Payment Pending',
  placed: 'Order Placed',
  confirmed: 'Confirmed',
  packed: 'Packed',
  shipped: 'Shipped',
  outForDelivery: 'Out for Delivery',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
};

export const ORDER_STATUS_COLORS = {
  paymentPending: '#DAA520',
  placed: '#ffc107',
  confirmed: '#17a2b8',
  packed: '#6f42c1',
  shipped: '#1B3A63',
  outForDelivery: '#fd7e14',
  delivered: '#28a745',
  cancelled: '#dc3545',
};

export const SIZE_OPTIONS = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'Free Size'];

export const SIZE_CHART = [
  { size: 'XS', bust: '32', waist: '26', hip: '34', bustCm: '81', waistCm: '66', hipCm: '86' },
  { size: 'S', bust: '34', waist: '28', hip: '36', bustCm: '86', waistCm: '71', hipCm: '91' },
  { size: 'M', bust: '36', waist: '30', hip: '38', bustCm: '91', waistCm: '76', hipCm: '97' },
  { size: 'L', bust: '38', waist: '32', hip: '40', bustCm: '97', waistCm: '81', hipCm: '102' },
  { size: 'XL', bust: '40', waist: '34', hip: '42', bustCm: '102', waistCm: '86', hipCm: '107' },
  { size: 'XXL', bust: '42', waist: '36', hip: '44', bustCm: '107', waistCm: '91', hipCm: '112' },
  { size: 'Free Size', bust: '36-44', waist: '28-38', hip: '36-46', bustCm: '91-112', waistCm: '71-97', hipCm: '91-117' },
];

export const COLORS = [
  { name: 'Red', hex: '#DC143C' },
  { name: 'Blue', hex: '#1B3A63' },
  { name: 'Green', hex: '#228B22' },
  { name: 'Yellow', hex: '#FFD700' },
  { name: 'Pink', hex: '#FF69B4' },
  { name: 'Purple', hex: '#800080' },
  { name: 'Orange', hex: '#FF8C00' },
  { name: 'White', hex: '#FFFFFF' },
  { name: 'Black', hex: '#000000' },
  { name: 'Maroon', hex: '#6B1420' },
  { name: 'Gold', hex: '#DAA520' },
  { name: 'Peach', hex: '#FFDAB9' },
];

export const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest First' },
  { value: 'price_low', label: 'Price: Low to High' },
  { value: 'price_high', label: 'Price: High to Low' },
  { value: 'popular', label: 'Most Popular' },
  { value: 'rating', label: 'Top Rated' },
];
